import * as requestFromServer from "./noticesCrud";
import { callTypes, noticesSlice } from "./noticesSlice";

const { actions } = noticesSlice;

export const fetchNotices = (queryParams) => (dispatch) => {
    dispatch(actions.startCall({ callType: callTypes.list }));

    return requestFromServer
        .FindNotices(queryParams)
        .then((response) => {
            const { totalCount, entities } = response.data;
            dispatch(actions.noticesFetched({ totalCount, entities }));
        })
        .catch((error) => {
            error.clientMessage = "رکورد های درخواستی یافت نشد.";
            dispatch(actions.catchError({ error, callType: callTypes.list }));
        });
};

export const fetchNotice = (id) => (dispatch) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    return requestFromServer
        .GetNoticeById(id)
        .then((response) => {
            const notice = response.data;
            dispatch(actions.noticeFetched({ noticeToView: notice }));
        })
        .catch((error) => {
            error.clientMessage = "فاکتور درخواستی یافت نشد";
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

export const createNotice = (noticeForCreation) => (dispatch) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    return requestFromServer
        .CreateNotice(noticeForCreation)
        .then((response) => {
            const notice = response.data;
            dispatch(actions.noticeCreated({ notice }));
        })
        .catch((error) => {
            error.clientMessage = "خطایی هنگام ایجاد اطلاعیه رخ داد";
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

export const updateNotice = (noticeForCreation) => (dispatch) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    return requestFromServer
        .EditNotice(noticeForCreation)
        .then((response) => {
            const notice = response.data;
            dispatch(actions.noticeFetched({ notice }));
        })
        .catch((error) => {
            error.clientMessage = "خطایی هنگام تغییر اطلاعات اطلاعیه رخ داد";
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

export const deleteNotice = id => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer
        .DeleteNotice(id)
        .then(() => {
            dispatch(actions.noticeDeleted({id}));
        })
        .catch((error) => {
            error.clientMessage = 'خطایی هنگام پاک کردن اطلاعیه رخ داد';
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        })
    
    
}
